import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { sizes } from '../../styles';

export interface Props {
  className?: string;
  label?: string;
  size?: Size;
}

/**
 * This component converts any given string into colored
 * circle with an arbitrary color selected based on the string
 * and an arbitrary one or two letter combination from the string
 */
class InitialsCoin extends React.Component<Props, any> {
  static defaultProps: Partial<Props> = {
    size: 'lg',
    label: '',
  };

  constructor(props: Props) {
    super(props);
    this.state = { color: '', initials: '' };
  }

  public buildInitials = (string): string => {
    const { label } = this.props;
    const splitLabel = label.trim().split(' ');
    const labelHasMultipleWords = splitLabel.length > 1;

    let initials = '';

    // tslint:disable-next-line:prefer-conditional-expression
    if (labelHasMultipleWords) {
      // Pulling the first letter of the first word and the first letter
      // of the last word to account for not grabbing middle names.
      initials = `${splitLabel[0][0]}${splitLabel[splitLabel.length - 1][0]}`;
    } else {
      // Single word, let's grab the first two characters if they're available,
      // otherwise just use the given character.
      initials = label.substr(0, label.length < 2 ? 1 : 2);
    }

    return initials;
  };

  public hashStringToColor = (string): { to: string; from: string } => {
    let h = 0;
    for (const char of string) {
      h += char.charCodeAt(0);
    }
    return {
      to: `hsl(${h % 360}, 80%, 45%)`,
      from: `hsl(${h % 360}, 85%, 50%)`,
    };
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.label !== this.props.label || nextProps.size !== this.props.size
    );
  }

  render() {
    const { className, label, size } = this.props;
    const color = this.hashStringToColor(label);

    return (
      <div
        className={`${className} ${size}`}
        style={{
          backgroundImage: `linear-gradient(0deg, ${color.to}, ${color.from})`,
        }}
      >
        {this.buildInitials(label)}
      </div>
    );
  }
}

const StyledInitialsCoin = styled(InitialsCoin)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 99px;
  text-transform: uppercase;

  ${sizes.createRules(sizes.coin)};
  &.md {
    font-size: 0.75rem;
  }
  &.sm {
    font-size: 0.7rem;
  }
  &.xs {
    font-size: 0.6rem;
  }
`;

export default StyledInitialsCoin;
